import { render, staticRenderFns } from "./FancyHeading.vue?vue&type=template&id=1f248257&scoped=true&"
import script from "./FancyHeading.vue?vue&type=script&lang=js&"
export * from "./FancyHeading.vue?vue&type=script&lang=js&"
import style0 from "./FancyHeading.vue?vue&type=style&index=0&id=1f248257&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f248257",
  null
  
)

export default component.exports